import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { styled } from "styled-components";
import { format } from "timeago.js";
import { Trash2 } from "lucide-react";
import UserAvatar from "./UserAvatar";
import Button from "./atoms/Button";

const Container = styled.div`
  display: flex;
  gap: 10px;
  margin: 30px 0px;
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const CommentContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
const Name = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colorOnBackground};
`;
const Date = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colorOnSurfaceVariant};
  margin-left: 5px;
`;
const Text = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colorOnBackground};
`;


const Comment = ({ comment }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [user, setUser] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/users/find/${comment.userId}`
      );
      setUser(res.data);
    };
    fetchUser();
  }, [comment]);

  const handleDeleteComment = async () => {
    if (comment.userId === currentUser._id) {
      await axios.delete(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/comments/${comment._id}`,
        {
          withCredentials: true,
        }
      );
    } else {
      console.log("No comment delete nono");
    }
  };
  return (
    <Container>
      <UserAvatar src={user?.img} name={user?.name} contrastColor={user?.contrastColor} size={24} />
      <CommentContent>
        <Details>
          <Name>
            {user?.name}
            <Date>{format(comment.createdAt)}</Date>
          </Name>
          <Text>{comment.desc}</Text>
        </Details>{" "}
        {currentUser?._id === comment.userId && (
          <Button variant="ghost" size="sm" icon={<Trash2 />} onClick={handleDeleteComment} />
        )}
      </CommentContent>
    </Container>
  );
};
export default Comment;
